/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ReplyIcon = ({ width = 24, height = 24, hidden = false, title = 'Reply' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M15.029 10H14V4.8a.8.8 0 0 0-.806-.8.785.785 0 0 0-.56.236L2.207 15.464a.8.8 0 0 0 0 1.072l10.427 11.228a.785.785 0 0 0 .56.236.8.8 0 0 0 .806-.8V22a19.71 19.71 0 0 1 18.791 6.81.67.67 0 0 0 1.209-.4C34 25.453 30.732 10 15.029 10Z"
    />
  </svg>`;
};
